import gql from 'graphql-tag';

export const DO_AMOUNT_TOTAL_PAYMENT = gql`
  query AMOUNT_TOTAL_PAYMENT($delivery: String!, $datePayment: String!) {
    amountTotalpayments(delivery: $delivery, datePayment: $datePayment)
  }
`;
